<template>
  <IQOSModal @backdropClick="$emit('close')">
    <template #title>
       {{ $t("transfer_dish.title") }}
    </template>

    <div>
      <BaseSelect class="w-100" v-model="menu_index">
        <option :value="null" disabled>
          {{ $t("transfer_dish.select_menu") }}
        </option>
        <option v-for="(m, idx) in menus" :key="m._id" :value="idx">
          {{ m.title }}
        </option>
      </BaseSelect>

      <BaseSelect class="w-100 mt-16" v-model="category_index" v-if="!menu_only">
        <option :value="null" disabled>
          {{ $t("transfer_dish.select_category") }}
        </option>
        <option v-for="(c, idx) in categories" :key="idx" :value="idx">
          {{ c.name }}
        </option>
      </BaseSelect>
    </div>
    <template #actions>
      <BaseButton variant="secondary" class="w-100" color="red-4" size="md" @click="emitClose">
        {{ $t("transfer_dish.cancel") }}
      </BaseButton>
      <BaseButton variant="secondary" class="w-100" color="v1-grey-3" size="md" @click="doTransfer">
        {{ $t("transfer_dish.confirm") }}
      </BaseButton>
    </template>
  </IQOSModal>
</template>

<script>
import BaseModal from "@/components/modals/BaseModal.vue";

export default {
  components: {
    BaseModal,
  },
  props: {
    menu_only: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      menu_index: null,
      category_index: null,
    };
  },
  methods: {
    emitClose() {
      this.$emit("close");
    },
    doTransfer() {
      if (this.category_index == -1) return;

      const menu_id = this.menus[this.menu_index]._id;

      const product = this.$store.state.menu.product;

      if (this.menu_only) {
        this.$emit('toMenu', menu_id);
        return;
      }

      const audit_payload = {
        src_menu_id: this.$store.state.menu.current._id,
        dst_menu_id: menu_id,
        dst_menu_title: this.menus[this.menu_index].title,
        dish_id: this.$store.state.menu.product._id,
        dish_name: this.$store.state.menu.product.name,
        dst_category_name: this.categories[this.category_index].name,
      };

      this.$store.commit("menu/transferProduct", {
        menu_id,
        category: this.categories[this.category_index],
      });

      if (this.$store.state.menu.current._id != menu_id) {
        this.$emit("transfered", true);
        this.$store.dispatch("menu/updateMenu", {
          id: menu_id,
        });
        this.$store.dispatch("menu/save");
      } else {
        this.$emit("transfered", false);
        this.$store.dispatch("menu/updateProduct", {
          product,
          menu_id
        });
      }

      

      this.$store.dispatch("auditlog/write", {
        type: "transfer_menu_product",
        payload: audit_payload,
      });

      this.emitClose();
    },
  },
  mounted() {
    this.menu_index = this.menus.findIndex(
      (m) => m._id == this.$store.state.menu.current._id
    );
    this.category_index = 0;
  },
  computed: {
    menus() {
      return this.$store.state.menu.menus;
    },
    categories() {
      if (this.menu_index == -1 || this.menu_index === null) return [];

      return this.menus[this.menu_index].categories;
    },
  },
};
</script>

<style>
.modal-controls {
  display: flex;
  justify-content: space-between;
}
</style>